import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Sarah M.',
    role: 'Mom of 2',
    quote: 'This saved my life. I used to spend hours worrying about what to pack, and now I have it down to 15 minutes. My kids actually eat their vegetables now!',
    initial: 'S'
  }, {
    name: 'Jessica P.',
    role: 'Mom of 1',
    quote: "The Picky Eater Solution (Bonus 1) is gold. My daughter refused everything green. Now she's asking for the 'Spinach Muffins' every morning!",
    initial: 'J'
  }, {
    name: 'Emily R.',
    role: 'Mom of 3',
    quote: 'The weekly meal plans are a game changer. I save so much money on groceries now and my son loves the variety. Highly recommend!',
    initial: 'E'
  }];
  return <section className="bg-gray-50 py-16 px-4" data-id="element-164">
      <div className="max-w-6xl mx-auto" data-id="element-165">
        <div className="text-center mb-12" data-id="element-166">
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#1f2e10] uppercase" data-id="element-167">
            What Moms Are Saying...
          </h2>
          <p className="text-gray-600 mt-2 font-medium" data-id="element-168">
            (Excellent 4.9/5 - Based on 1,245 reviews)
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-169">
          {testimonials.map((testimonial, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-md border border-gray-100 relative" data-id="element-170">
              <div className="absolute -top-3 -right-3 bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-full flex items-center gap-1 shadow-sm" data-id="element-171">
                <CheckCircle2 size={12} data-id="element-172" /> Verified
              </div>
              <div className="flex gap-1 mb-4 text-[#c4f000]" data-id="element-173">
                {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-5 h-5 fill-current" viewBox="0 0 20 20" data-id="element-174">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-175" />
                  </svg>)}
              </div>
              <p className="text-gray-700 italic mb-6 leading-relaxed" data-id="element-176">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-3" data-id="element-177">
                <div className="w-10 h-10 rounded-full bg-[#1f2e10] text-[#c4f000] flex items-center justify-center font-bold text-lg" data-id="element-178">
                  {testimonial.initial}
                </div>
                <div data-id="element-179">
                  <h4 className="font-bold text-[#1f2e10]" data-id="element-180">
                    {testimonial.name}
                  </h4>
                  <p className="text-xs text-gray-500" data-id="element-181">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}